import { NgModule } from '@angular/core';
import { API_BASE_URL } from 'Nswag/nswag-api-sps';
import { environment } from 'environments/environment';
import { SpService } from 'app/core/services/sp.service';

@NgModule({
    providers: [
        SpService,
        {
            provide: API_BASE_URL,
            useValue: environment.API_BASE_URL,
        }
    ]
})
export class SpModule { }
